import React from 'react';
import { Users, Target, CheckCircle2, TrendingUp } from 'lucide-react';
import { StatCard } from '../components/StatCard';
import { LineChart, Line, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
const userGrowthData = [{
  month: 'Jan',
  users: 1200
}, {
  month: 'Fev',
  users: 1900
}, {
  month: 'Mar',
  users: 2400
}, {
  month: 'Abr',
  users: 3200
}, {
  month: 'Mai',
  users: 4100
}, {
  month: 'Jun',
  users: 5200
}];
const categoryData = [{
  name: 'Carreira',
  value: 2400,
  color: '#8BC4C3'
}, {
  name: 'Saúde',
  value: 1800,
  color: '#2C4A6B'
}, {
  name: 'Viagens',
  value: 1600,
  color: '#6BABA9'
}, {
  name: 'Relacionamentos',
  value: 1200,
  color: '#9DC5C3'
}, {
  name: 'Sonho-chave',
  value: 900,
  color: '#1E3A5F'
}];
const statusData = [{
  name: 'Realizado',
  value: 6847,
  color: '#10B981'
}, {
  name: 'Em andamento',
  value: 9234,
  color: '#8BC4C3'
}, {
  name: 'Planejado',
  value: 1823,
  color: '#F59E0B'
}, {
  name: 'Sonhando',
  value: 588,
  color: '#6366F1'
}];
export function Dashboard() {
  return <div className="space-y-6" data-id="element-200">
      <div data-id="element-201">
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-202">Dashboard</h1>
        <p className="text-gray-600 mt-1" data-id="element-203">Visão geral do iDreamy</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-204">
        <StatCard title="Total de Usuários" value="5.234" change="Usuários neste período" trend="up" icon={Users} color="green" data-id="element-205" />
        <StatCard title="Usuários Ativos (7d)" value="3.847" change="Ativos neste período" trend="up" icon={TrendingUp} color="blue" data-id="element-206" />
        <StatCard title="Total de Sonhos" value="18.492" change="Sonhos neste período" trend="up" icon={Target} color="cyan" data-id="element-207" />
        <StatCard title="Taxa de Conclusão" value="68,4%" change="Conclusões neste período" trend="up" icon={CheckCircle2} color="purple" data-id="element-208" />
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-209">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-210">
          Crescimento de Usuários
        </h3>
        <ResponsiveContainer width="100%" height={300} data-id="element-211">
          <LineChart data={userGrowthData} data-id="element-212">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-213" />
            <XAxis dataKey="month" stroke="#9ca3af" data-id="element-214" />
            <YAxis stroke="#9ca3af" data-id="element-215" />
            <Tooltip data-id="element-216" />
            <Line type="monotone" dataKey="users" stroke="#8BC4C3" strokeWidth={3} dot={{
            fill: '#8BC4C3',
            r: 4
          }} data-id="element-217" />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-218">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-219">
          <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-220">
            Sonhos por Categoria
          </h3>
          <ResponsiveContainer width="100%" height={300} data-id="element-221">
            <PieChart data-id="element-222">
              <Pie data={categoryData} cx="50%" cy="50%" labelLine={false} label={({
              name,
              percent
            }) => `${name} ${(percent * 100).toFixed(0)}%`} innerRadius={60} outerRadius={100} fill="#8884d8" dataKey="value" data-id="element-223">
                {categoryData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-224" />)}
              </Pie>
              <Tooltip data-id="element-225" />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-226">
          <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-227">
            Sonhos por Status
          </h3>
          <ResponsiveContainer width="100%" height={300} data-id="element-228">
            <PieChart data-id="element-229">
              <Pie data={statusData} cx="50%" cy="50%" labelLine={false} label={({
              name,
              percent
            }) => `${name} ${(percent * 100).toFixed(0)}%`} innerRadius={60} outerRadius={100} fill="#8884d8" dataKey="value" data-id="element-230">
                {statusData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-231" />)}
              </Pie>
              <Tooltip data-id="element-232" />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>;
}